import { render, staticRenderFns } from "./RemoveAssetModal.vue?vue&type=template&id=b0333ade"
import script from "./RemoveAssetModal.vue?vue&type=script&lang=js"
export * from "./RemoveAssetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports